import React from 'react'

const Tick = ({width='16', height='16'}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M0.689209 11C0.689209 5.30552 5.30552 0.689209 11 0.689209C16.6945 0.689209 21.3108 5.30552 21.3108 11C21.3108 16.6945 16.6945 21.3108 11 21.3108C5.30552 21.3108 0.689209 16.6945 0.689209 11ZM16.2184 8.11033C16.4137 7.91507 16.4137 7.59848 16.2184 7.40322C16.0232 7.20796 15.7066 7.20796 15.5113 7.40322L9.3784 13.5362L6.48871 10.6465C6.29345 10.4512 5.97686 10.4512 5.7816 10.6465C5.58634 10.8417 5.58634 11.1583 5.7816 11.3536L9.02484 14.5968C9.22011 14.7921 9.53669 14.7921 9.73195 14.5968L16.2184 8.11033Z" fill="#228568" />
    </svg>
  )
}

export default Tick